import Papa from 'papaparse';
const assetsPath = window.assetsPath;
const imgPath = window.imgPath;

// 地方名→キー名変換表
const regionKeyMap = {
  "北海道地方": "hokkaido",
  "東北地方": "tohoku",
  "中部地方": "chubu1",
  "関東地方": "kanto",
  "中国地方": "chuugoku",
  "近畿地方": "kansai",
  "四国地方": "shikoku1",
  "九州・沖縄地方": "kyushu1"
};

const regionNameMap = {
  hokkaido: "北海道",
  tohoku: "東北",
  chubu1: "中部",
  chubu2: "中部",
  kanto: "関東",
  chuugoku: "中国",
  kansai: "近畿",
  shikoku1: "四国",
  shikoku2: "四国",
  kyushu1: "九州・沖縄",
  kyushu2: "九州・沖縄",
  kyushu3: "九州・沖縄",
  kyushu4: "九州・沖縄"
};

fetch(assetsPath+'data/region_members.csv')
  .then(response => response.text())
  .then(csvText => {
    const result = Papa.parse(csvText, {
      header: true,
      skipEmptyLines: true
    });

    // 地域ごとにグループ化
    const regionMembers = {};
    result.data.forEach(row => {
      const regionKey = regionKeyMap[row["地方"]];
      if (!regionKey) return;
      const member = {
        term: row["期"],
        company: row["ホテル名"],
        name: row["氏名"],
        icon: row["プロフィール画像ファイル名"]
          ? imgPath + row["プロフィール画像ファイル名"]
          : imgPath + 'icon_default.png',
        prefecture: row["都道府県"],
        text: row["温泉・エリア"],
        img: row["ホテル画像ファイル名"],
        url: row["リンク"]
      };
      if (!regionMembers[regionKey]) regionMembers[regionKey] = [];
      regionMembers[regionKey].push(member);
    });

    // 地図イベントや初期表示の処理をここで定義
    const paths = document.querySelectorAll('#japan-map path');
    const regionTitleEl = document.querySelector('.p-home__tsugiboshiMapRegion');
    const contentsEl = document.querySelector('.p-home__tsugiboshiMapContents');

    paths.forEach(path => {
      path.addEventListener('click', function() {
         // すべてのpathのスタイルをリセット
				paths.forEach(p => {
					p.style.fill = '';
					p.style.stroke = '#BDBDBD';
					p.style.strokeWidth = '';
				});

				// chubu, shikoku, kyushuグループ対応
        let regionKey = this.id;
        let highlightIds = [];
        if (regionKey === 'chubu1' || regionKey === 'chubu2') {
          highlightIds = ['chubu1', 'chubu2'];
          regionKey = 'chubu1';
        } else if (regionKey === 'shikoku1' || regionKey === 'shikoku2') {
          highlightIds = ['shikoku1', 'shikoku2'];
          regionKey = 'shikoku1';
        } else if (
          regionKey === 'kyushu1' ||
          regionKey === 'kyushu2' ||
          regionKey === 'kyushu3' ||
          regionKey === 'kyushu4'
        ) {
          highlightIds = ['kyushu1', 'kyushu2', 'kyushu3', 'kyushu4'];
          regionKey = 'kyushu1';
        } else {
          highlightIds = [regionKey];
        }

				// 対象pathをハイライト
        highlightIds.forEach(id => {
          const el = document.getElementById(id);
          if (el) {
            el.style.fill = '#F2E56B';
            el.style.stroke = '#EB5C01';
            el.style.strokeWidth = '1px';
            el.parentNode.appendChild(el);
          }
        });

        regionTitleEl.textContent = regionNameMap[regionKey] + "地方";
        const members = regionMembers[regionKey] || [];
        contentsEl.innerHTML = members.map(member => `
          <div class="p-home__tsugiboshiMapItem">
						<div class="p-home__tsugiboshiMapItemHead">
							${member.icon
								? `<div class="p-home__tsugiboshiMapItemIcon"><img src="${member.icon}" alt=""></div>`
								: ''}
							<div class="p-home__tsugiboshiMapItemProf">
								<p class="p-home__tsugiboshiMapItemTerm">
									<span class="-en">TSUGIBOSI</span>
									<span class="-ja">${member.term}</span>
								</p>
								<p class="p-home__tsugiboshiMapItemName">${member.name}<span>さん</span></p>
							</div>
						</div>
						<div class="p-home__tsugiboshiMapItemBody">
							<div class="p-home__tsugiboshiMapItemImg">
								<img src="${member.img}" alt="">
							</div>
							<span class="p-home__tsugiboshiMapItemPrefectures">${member.prefecture}</span>
							<p class="p-home__tsugiboshiMapItemCompany">
								${member.text ? `<span>${member.text}&nbsp;</span>` : ''}
								${member.company}
							</p>
							${member.url
								? `<div class="p-home__tsugiboshiMapItemLink"><a href="${member.url}" target="_blank">じゃらんで見る</a></div>`
								: ''}
						</div>
					</div>
        `).join('');
      });
    });

    // 初期表示
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', showInitialRegion);
    } else {
      showInitialRegion();
    }

    function showInitialRegion() {
      ['tohoku'].forEach(id => {
        const el = document.getElementById(id);
        if (el) {
          el.style.fill = '#F2E56B';
          el.style.stroke = '#EB5C01';
          el.style.strokeWidth = '1px';
          el.parentNode.appendChild(el);
        }
      });
      regionTitleEl.textContent = regionNameMap['tohoku'] + "地方";
      const members = regionMembers['tohoku'] || [];
      contentsEl.innerHTML = members.map(member => `
        <div class="p-home__tsugiboshiMapItem">
					<div class="p-home__tsugiboshiMapItemHead">
						${member.icon
							? `<div class="p-home__tsugiboshiMapItemIcon"><img src="${member.icon}" alt=""></div>`
							: ''}
						<div class="p-home__tsugiboshiMapItemProf">
							<p class="p-home__tsugiboshiMapItemTerm">
								<span class="-en">TSUGIBOSI</span>
								<span class="-ja">${member.term}</span>
							</p>
							<p class="p-home__tsugiboshiMapItemName">${member.name}<span>さん</span></p>
						</div>
					</div>
					<div class="p-home__tsugiboshiMapItemBody">
						<div class="p-home__tsugiboshiMapItemImg">
							<img src="${member.img}" alt="">
						</div>
						<span class="p-home__tsugiboshiMapItemPrefectures">${member.prefecture}</span>
						<p class="p-home__tsugiboshiMapItemCompany">
							${member.text ? `<span>${member.text}&nbsp;</span>` : ''}
							${member.company}
						</p>
						${member.url
							? `<div class="p-home__tsugiboshiMapItemLink"><a href="${member.url}" target="_blank">じゃらんで見る</a></div>`
							: ''}
					</div>
				</div>
      `).join('');
    }
  });
